import { Modal } from "@/shared/components/Modal";
import { Button } from "@/shared/components/form/Button";
import { CheckCircle } from "lucide-react";
import useTranslations from "@/shared/lang/useTranslations";

interface DeleteOrganizationSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DeleteOrganizationSuccessModal = ({
  isOpen,
  onClose,
}: DeleteOrganizationSuccessModalProps) => {
  const { t } = useTranslations("cards");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("delete_organization_success_modal_title")}
      size="md"
      footer={
        <Button variant="primary" onClick={onClose}>
          {t("delete_organization_success_modal_button_ok")}
        </Button>
      }
    >
      <div className="space-y-4">
        <div className="flex items-center justify-center">
          <div className="rounded-full bg-green-100 dark:bg-green-900/30 p-3">
            <CheckCircle className="h-8 w-8 text-green-600 dark:text-green-400" />
          </div>
        </div>

        <p className="text-center text-sm text-gray-600 dark:text-gray-400">
          {t("delete_organization_success_modal_message")}
        </p>
      </div>
    </Modal>
  );
};
